import axios from 'axios';
import DatricRequests from '../datric.requests';
import { Batch } from '../../../models/batch.model';

const requests = new DatricRequests();
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3050';

export async function createBatchJson(name: string, cpfs: string[]): Promise<Batch> {
	return requests.post('batches', { name, cpfs });
}

export async function createBatchFile(name: string, file: File): Promise<Batch> {
	const form = new FormData();
	form.append('name', name);
	form.append('file', file);
	return requests.post('batches', form, {
		headers: { 'Content-Type': 'multipart/form-data' }
	});
}

export async function listBatches(): Promise<Batch[]> {
	return requests.get('batches');
}

export async function getBatch(id: string): Promise<Batch> {
	return requests.get(`batches/${id}`);
}

export async function downloadBatch(id: string): Promise<void> {
	const token = localStorage.getItem('token');
	const response = await axios.get(`${API_URL}/batches/${id}/download`, {
		responseType: 'blob',
		headers: { Authorization: `Bearer ${token}` }
	});

	// O servidor pode responder um erro (JSON) mesmo com status 2xx improvável, ou
	// um blob de erro; garante que o conteúdo baixado é de fato o CSV.
	const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });

	// Usa o nome do arquivo enviado pelo servidor (Content-Disposition) quando houver.
	const disposition: string = response.headers?.['content-disposition'] || '';
	const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
	const filename = match ? decodeURIComponent(match[1]) : `lote-${id}.csv`;

	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', filename);
	document.body.appendChild(link);
	link.click();
	link.remove();
	// Revoga só depois que o navegador iniciou o download; revogar na mesma
	// tick cancela o download em alguns navegadores.
	setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}
